import { Box, BoxProps } from '@chakra-ui/react';
import fonts from 'src/theme/fonts';
import colors from 'src/theme/colors';

function AttentionBox(props: BoxProps) {
  return (
    <Box
      border="1px solid"
      borderColor="podcastPurple800"
      color={colors.white}
      bg="podcastPurple800"
      display="inline-block"
      borderRadius="6px"
      px="8px"
      py="6px"
      textShadow="0px 1px 1px rgba(0, 0, 0, 0.15)"
      fontSize="12px"
      lineHeight="12px"
      fontFamily={fonts.bold}
      textAlign="center"
      {...props}
    />
  );
}

export default AttentionBox;
